Application.Postcard.Color = {
    ui: {
        container: '.js-postcard-color',
        previewIconContainer: '.js-postcard-color__preview-icon-container',
        previewIcon: '.js-postcard-color__preview-icon',
        inputSvg: '.js-postcard-color__input-svg'
    },
    previewList: null,
    svgIcon: null,
    state: {
        iconReady: false
    },
    handlers: {
        iconReady: []
    },
    ready: function (previewList) {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.previewList = previewList;

        // bind handlers
        this.bind();

        // create icon
        this.svgIcon = new Application.SvgIcon();
        $(this.ui.previewIcon).empty().append(this.svgIcon.element);

        // set icon
        this.icon($(this.ui.previewIcon).attr('data-icon'), parseFloat($(this.ui.previewIcon).attr('data-icon-width-ratio')), parseFloat($(this.ui.previewIconContainer).attr('data-x')), false, function (){
            self.triggerIconReady();
        });

    },
    bind: function(){

        var self = this;

        // update color when requested
        this.previewList.setOnChange(function(id, src, data){
            self.color(id, src);
        });

    },
    color: function(id, src){

        var self = this;

        this.onIconReady(function(){

            // icon
            self.svgIcon.setBackground(src, function(){
                // resize background
                var bbox = self.svgIcon.getBackgroundBbox();
                var coeff = 0.9;
                var newW = bbox.w * coeff;
                var newH = bbox.h * coeff;
                var newX = bbox.x + bbox.w * (1 - coeff) / 2;
                var newY = bbox.y + bbox.h * (1 - coeff) / 2;
                self.svgIcon.resizeBackground(newW, newH);
                self.svgIcon.moveBackground(newX, newY);
                // update input
                self.updateInput();
                // mark as ready
                $(self.ui.container).removeClass('step-preview_loading');
            });

        });

    },
    icon: function(src, ratio, x, isPng, callback){

        var self = this;

        // change size
        $(this.ui.previewIconContainer).css('width', (ratio * $(this.ui.previewIconContainer).data('width')) + 'em');
        // set x position
        $(this.ui.previewIconContainer).css('margin-left', (x * $(this.ui.previewIconContainer).data('width')) + 'em');

        // change icon
        if (isPng){
            this.svgIcon.setPng(src, Application.SvgIcon.FIT_WIDTH, function(){
                // mark as ready
                $(self.ui.container).removeClass('step-preview_loading');
                // callback
                if(typeof callback == 'function'){
                    callback();
                }
            });
        }else{
            this.svgIcon.setIcon(src, $(this.ui.previewIconContainer).attr('data-color'), Application.SvgIcon.FIT_WIDTH, function(){
                // mark as ready
                $(self.ui.container).removeClass('step-preview_loading');
                // callback
                if(typeof callback == 'function'){
                    callback();
                }
            });
        }

    },
    onIconReady: function(callback){

        if (this.state.iconReady){
            callback();
        }else{
            this.handlers.iconReady.push(callback);
        }

    },
    triggerIconReady: function(){

        // save state
        this.state.iconReady = true;

        // call
        for(var z in this.handlers.iconReady){
            if(!this.handlers.iconReady.hasOwnProperty(z)){
                continue;
            }
            this.handlers.iconReady[z].call(this);
        }
        // and reset
        this.handlers.iconReady = [];

    },
    updateInput: function(){

        $(this.ui.inputSvg).val(this.svgIcon.getSvg());

    }
};